import React from 'react';
import { cn } from '@/lib/utils';

// Portfolio Pal Logo Component
// Based on brand guidelines: House (roof) + Portfolio (ledger lines) fusion mark

export const LogoMark = ({ size = 40, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Portfolio Pal logo"
  >
    {/* Anchor Blue rounded container */}
    <rect width="48" height="48" rx="10" fill="#1E40AF" />
    {/* House with roof and ledger lines */}
    <g transform="translate(8, 10)">
      {/* Sunbeam Amber roof */}
      <path d="M16 4L4 14H28L16 4Z" fill="#F59E0B" />
      {/* White house body */}
      <rect x="8" y="14" width="16" height="14" fill="white" rx="1" />
      {/* Ledger lines */}
      <line x1="10" y1="18" x2="22" y2="18" stroke="#E2E8F0" strokeWidth="1.5" />
      <line x1="10" y1="22" x2="22" y2="22" stroke="#E2E8F0" strokeWidth="1.5" />
      <line x1="10" y1="26" x2="18" y2="26" stroke="#E2E8F0" strokeWidth="1.5" />
    </g>
  </svg>
);

export const LogoWordmark = ({ size = 40, showText = true, className }) => (
  <div className={cn("flex items-center gap-2", className)}>
    <LogoMark size={size} />
    {showText && (
      <span className="font-display font-bold tracking-tight" style={{ fontSize: size * 0.45 }}>
        <span className="text-ink">Portfolio</span>
        <span className="text-signal-blue"> Pal</span>
      </span>
    )}
  </div>
);

// Reversed version for dark backgrounds
export const LogoMarkReversed = ({ size = 40, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Portfolio Pal logo"
  >
    {/* White rounded container for reversed */}
    <rect width="48" height="48" rx="10" fill="white" />
    <g transform="translate(8, 10)">
      {/* Sunbeam Amber roof */}
      <path d="M16 4L4 14H28L16 4Z" fill="#F59E0B" />
      {/* Anchor Blue house body */}
      <rect x="8" y="14" width="16" height="14" fill="#1E40AF" rx="1" />
      {/* Light ledger lines */}
      <line x1="10" y1="18" x2="22" y2="18" stroke="#2563EB" strokeWidth="1.5" strokeOpacity="0.4" />
      <line x1="10" y1="22" x2="22" y2="22" stroke="#2563EB" strokeWidth="1.5" strokeOpacity="0.4" />
      <line x1="10" y1="26" x2="18" y2="26" stroke="#2563EB" strokeWidth="1.5" strokeOpacity="0.4" />
    </g>
  </svg>
);

export const LogoWordmarkReversed = ({ size = 40, showText = true, className }) => (
  <div className={cn("flex items-center gap-2", className)}>
    <LogoMarkReversed size={size} />
    {showText && (
      <span className="font-display font-bold tracking-tight text-white" style={{ fontSize: size * 0.45 }}>
        Portfolio Pal
      </span>
    )}
  </div>
);

export default LogoWordmark;
